import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftHide32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSidebarLeftHide32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 8h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H13zm-2 18H7c-1.12 0-2.132-.46-2.858-1.201H4v-.153A4 4 0 0 1 3 22V10a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4zm10.515-13.072a1 1 0 0 0-1.415-1.414l-3.535 3.535-.707.708.707.707 3.535 3.535a1 1 0 0 0 1.415-1.414l-2.829-2.828z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftHide32Filled);
